export default __webpack_public_path__ + "static/media/ICON-Home.15ebb008.svg";